import React from "react";
import s from "./MainEducation.module.css";
import TopTitleBlock from "../../Components/TopTitleBlock/TopTitleBlock";
import MainEducationProgressLineTop from "./EducationComponents/MainEducationProgressLineTop";
import EducationOneModuleElement from "./EducationComponents/EducationOneModuleElement";
import EducationBackButton from "../../Components/Buttons/EducationBackButton";
import {useSelector} from "react-redux";

const EducationModuleSubModulePage = () => {

  const apiData = useSelector((state)=>state.appData.appData)
  return (
    <main className={`${s.mainEducation} page`}>
      <div className="container">
        <div className="page__content">
          <TopTitleBlock
            titleBack={apiData.button_back}
            pagination={
              "PRODUCT SCHOOL > White mandarin > Модуль 3. Огляд продуктів "
            }
          />
          <EducationBackButton />
          <div className={s.titleLesson}>
            <h3>модуль 3</h3>
          </div>
          <div className={s.contentContainer}>
            <MainEducationProgressLineTop text={"Огляд продуктів"} />
            <ul className={s.lessonsListContainer}>
              <EducationOneModuleElement
                title={"догляд за шкірою обличчя"}
                link={"lessons"}
              />
              <EducationOneModuleElement title={"догляд за тілом"} />
              <EducationOneModuleElement title={"догляд за волоссям"} />
              <EducationOneModuleElement title={"дитяча серія"} />
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
};

export default EducationModuleSubModulePage;
